import axios from "axios";
import { buildQuery } from "utils/queryUtils";

export const findRelations = (headers, params) => {
    let query = buildQuery(params, []);
    return axios.get(`${process.env.REACT_APP_CATEGORY_API_URL}/relations${query}`, {
        headers,
    });
};

export const findRelationById = (headers, id) => {
    return axios.get(`${process.env.REACT_APP_CATEGORY_API_URL}/relations/${id}`, {
        headers,
    });
};
